import { render, staticRenderFns } from "./winners.vue?vue&type=template&id=d24a44ca"
import script from "./winners.vue?vue&type=script&lang=js"
export * from "./winners.vue?vue&type=script&lang=js"
import style0 from "./winners.vue?vue&type=style&index=0&id=d24a44ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports